// TEMP: Please change the source urls prior to deploying. Preferably host the files somewhere more permanent.
// Local files don't seem to play nice with node. This behavior may differ on the production environment.
export const audioSources = {
  error: "sounds/alert.mp3",
  onCaptureReady: "sounds/capture.mp3",
};
